class ProductCard extends HTMLElement {
    constructor(){
        super();
        this.isCollection = this.dataset.isCollection == 'true'
    }

    connectedCallback() {
        this.listener();
        this.unavailableIconDisabled();
        const swatch = Array.from(this.querySelectorAll('[data-swatch-color]'))
            .find(swatch => swatch.dataset.variantLabelNew == 'true' && swatch.dataset.variantAvailable == "true");
        if (swatch) {
            this.changeProduct(swatch);
        }
    }

    unavailableIconDisabled() {
        const colorCards = this.querySelectorAll('.color-swatch-img-wrapper');
        colorCards.forEach((colorCard) => {
            colorCard.style.opacity = colorCard.getAttribute('data-variant-available') == "false" ? 0.3 : 1;
        })
    }

    listener() {
        this.addEventListener('click', (event) => {
          let colorSwatchClicked = event.target.closest('.color-swatch-img-wrapper');
          if (colorSwatchClicked) {
              this.changeProduct(colorSwatchClicked);
          }
        });
      }
      

    changeProduct(colorSwatchCliccked) {
        if (colorSwatchCliccked.classList.contains('tw-color-swatch--active')) return

        this.querySelectorAll('.color-swatch-img-wrapper').forEach(function(element) {
            element.classList.remove('tw-color-swatch--active');
        });
        // GESTIONE COLOR SWATCH
        colorSwatchCliccked.classList.add('tw-color-swatch--active');
        let variantPriceByClerk = colorSwatchCliccked.getAttribute('data-clerk-price');
        let variantColor = colorSwatchCliccked.getAttribute('data-swatch-color');
        let variantUrl = colorSwatchCliccked.getAttribute('data-variant-url');
        let variantAvailable = colorSwatchCliccked.getAttribute('data-variant-available');
        let variantNew = colorSwatchCliccked.getAttribute('data-variant-label-new');
        let variantOnSale = colorSwatchCliccked.getAttribute('data-variant-onsale');
        let badgeSoldOut = this.querySelector('.card__badges .badge--sold-out');
        let badgeNew = this.querySelector('.card__badges .badge--new');
        let badgeOnSale = this.querySelector('.card__badges .badge--sale');

        let discountPercentage = colorSwatchCliccked.getAttribute('variant-discount-percentage');
        let priceContainer = this.querySelector('.price-snippet');

        let cardInformationLinks = this.querySelectorAll('.card__information a');

        // GESTIONE LINKS
        cardInformationLinks.forEach(function(element) {
            element.setAttribute("href", variantUrl);
        });

        // GESTIONE IMMAGINI
        let cardImages = this.querySelectorAll('.card__media .media');
        cardImages.forEach(function (element) {
            element.classList.remove('tw-plp-media--active');

            if (element.getAttribute('data-variant-img-color') == variantColor) {
                element.classList.add('tw-plp-media--active');
                element.querySelector("a").setAttribute("href", variantUrl);
            }
        });

        if (badgeNew) {
            badgeNew.style.display = variantNew == 'true' ? "block" : "none";
        }

        // GESTIONE CARD BADGES
        if (badgeSoldOut && badgeOnSale) {
            const unavailable = variantAvailable == "false"
            colorSwatchCliccked.style.opacity = unavailable ? 0.3 : true;
            badgeSoldOut.style.display = unavailable ? "block" : "none";

            if (unavailable) {
                badgeOnSale.style.display = "none";
                badgeSoldOut.innerHTML = variantNew ? window.variantStrings.newSoldOut : window.variantStrings.soldOut;
            } else {
                badgeOnSale.style.display = variantOnSale == "true" ?  "block" : "none";
            }
        }

        // GESTIONE CARD PRICE
        if (discountPercentage) {
            if (!priceContainer.classList.contains('price--on-sale')) {
                priceContainer.classList.add('price--on-sale');
            }
            let salePriceContainer = this.querySelector('.price__sale .price-item.price-item--sale.price-item--last');
            let newPrice = colorSwatchCliccked.getAttribute('data-variant-price');
            salePriceContainer.innerHTML = newPrice;

            let saleComparePriceContainer = this.querySelector('.price__sale .price-item--regular');
            let newComparePrice = colorSwatchCliccked.getAttribute('data-variant-compare-price');
            saleComparePriceContainer.innerHTML = newComparePrice;

            let salePercentageContainer = this.querySelector('.price__sale .price__sale__percentage');
            let newDiscPercentage = colorSwatchCliccked.getAttribute('variant-discount-percentage');
            salePercentageContainer.innerHTML = `-${newDiscPercentage}%`;

        }else if (discountPercentage == null){
            if (priceContainer && priceContainer.classList.contains('price--on-sale')) {
                priceContainer.classList.remove('price--on-sale');
            }

            let regularPriceContainer = this.querySelector('.price__regular .price-item.price-item--regular');
            let newPrice = colorSwatchCliccked.getAttribute('data-variant-price');

            /* [BT-2690] ottengo valore da Clerk nella SERP
            se non è presente prende invece data-variant-price */

            if(variantPriceByClerk) {
                newPrice = variantPriceByClerk
            }

            regularPriceContainer.innerHTML = newPrice;

        }


    }
}

customElements.define('product-card', ProductCard);
